import { Unit } from '../App'
import type { WeatherForecast } from '../api/weather'

const weekdayFmt = new Intl.DateTimeFormat(undefined, { weekday: 'long' })
const dateFmt = new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'short' })

function summaryIcon(summary: string | null): string {
  switch (summary) {
    case 'Freezing':
    case 'Bracing':
    case 'Chilly':
      return '❄️'
    case 'Cool':
    case 'Mild':
      return '🌤️'
    case 'Warm':
    case 'Balmy':
      return '☀️'
    case 'Hot':
    case 'Sweltering':
    case 'Scorching':
      return '🔥'
    default:
      return '🌡️'
  }
}

export function WeatherCard({ forecast, unit }: { forecast: WeatherForecast; unit: Unit }) {
  // Treat the date as local midnight so the weekday label is stable.
    const date = new Date(`${forecast.date}T00:00:00`)
    const temperature = unit === 'C' ? forecast.temperatureC : forecast.temperatureF  // derived

  return (
    <li className="card">
      <div className="card__day">
        <span className="card__weekday">{weekdayFmt.format(date)}</span>
        <span className="card__date">{dateFmt.format(date)}</span>
      </div>
      <div className="card__icon" aria-hidden="true">
        {summaryIcon(forecast.summary)}
      </div>
          <div className="card__temp">
              <span className="card__c">{temperature}°{unit}</span>
      {/*  <span className="card__c">{forecast.temperatureC}°C</span>*/}
      {/*  <span className="card__f">{forecast.temperatureF}°F</span>*/}
      </div>
      <div className="card__summary">{forecast.summary ?? '—'}</div>
    </li>
  )
}
